import { Injectable } from '@angular/core';

@Injectable()
export class SampleQuoteService {

  constructor() {
  }

  // sample async method
  getQuote() {
    return Promise.resolve('ActualSampleQuoteHere');
  }

}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/sample-banner/sample-quote.service.ts